import { useState } from 'react';
import { useTypeHeaderIcon } from '../../../../../utils/hooks/useTypeHeaderIcon';
import { useAuth } from '../../../../../utils/Auth';
import styles from './PostSurveyOptions.module.css';
import ThankYouCard from './ThankYouCard';

export default function PostSurveyOptions() {
    const { qr_data, dataDispatch } = useAuth();
    const { header } = useTypeHeaderIcon(qr_data?.data?.qr_type);
    const [ radio, setRadio ] = useState('1');

    const handleUrl = e => {
        dataDispatch({type: 'survey', data: { post_survey_options: { ...qr_data?.data?.survey?.post_survey_options, url: e.target.value }}});
    };

    const handleReturn = () => {
        switch(radio) {
            case '2':
                return (
                    <div className={styles.card}>
                        <div className={styles.cardTitle}>Redirect Link</div>
                        <div className={styles.cardBody}>
                            <div className={styles.inputGroup}>
                                <input id='post-survey-url' type='url' className={styles.input} maxLength='100' defaultValue={qr_data?.data?.survey?.post_survey_options?.url} onChange={handleUrl} />
                                <label htmlFor='post-survey-url' className={styles.label}>Post {header} URL</label>
                            </div>
                        </div>
                    </div>
                    );
            case '1':
            default:
                return (
                    <ThankYouCard />
                );
        };
    };

    return (
        <div className={styles.container}>
            <h5>Submission Action</h5>
            <div className={styles.radioBtnWrap}>
                <input type='radio' className={styles.radio} id='radio-thanks' value='1' checked={radio === '1'} onChange={e => setRadio(e.target.value)} />
                <label htmlFor='radio-thanks' className={radio === '1' ? `${styles.radioBtn} ${styles.selected}` : styles.radioBtn}>Thank You Page</label>
                <input type='radio' className={styles.radio} id='radio-redirect' value='2' checked={radio === '2'} onChange={e => setRadio(e.target.value)} />
                <label htmlFor='radio-redirect' className={radio === '2' ? `${styles.radioBtn} ${styles.selected}` : styles.radioBtn}>Redirect</label>
            </div>
            {handleReturn()}
        </div>
    );
};
